export enum CONTENT_PACKAGE_TYPE {
  SCORM = 'SCORM',
}

export enum CONTENT_PACKAGE_VERSION {
  SCORM_1_2 = 'SCORM_1_2',
  SCORM_2004 = 'SCORM_2004',
}
export * from './model';
